<template>
    <!--授权委托书-->
    <div style="padding: 20px">
        <h1 style="text-align: center">授权委托书</h1>
        <h3>编号：</h3>
        <h3>点价宝科技（四川）有限公司：</h3>
        <p style="text-indent: 2em">
            现我司____________________向贵司申请会员资格认证，并授权下列指定人员作为我司代理人，办理授权范围内的各项事宜。
        </p>
        <h3>授权范围：</h3>
        <p>
            1、办理我司与贵司发生的各类合作事宜（包括但不限于线上交易、维护账户信息、签订书面文件等）。
        </p>
        <p>2、管理我司关联用户的账号（包括但不限于查询、添加、删除等）。</p>
        <p>3、授权其他关联用户通过贵司电商平台进行线上交易。</p>
        <!-- <p>4、协议有效期：自______年______月______日至______年______月______日。</p> -->
        <h3>代理人信息：</h3>
        <table style="border: none">
            <tr>
                <td align="left" style="border: 1px solid #ccc; padding-left: 10px">
                    代理人姓名：
                </td>
                <td
                    align="left"
                    style="
                        border-color: #ccc;
                        border-style: solid;
                        padding-left: 10px;
                        border-width: 1px 1px 1px 0px;
                    ">
                    用户名：
                </td>
            </tr>
            <tr>
                <td
                    align="left"
                    style="border: 1px solid #ccc; border-top: 0px; padding-left: 10px">
                    代理人身份证号码：
                </td>
                <td
                    align="left"
                    style="
                        border-color: #ccc;
                        border-style: solid;
                        padding-left: 10px;
                        border-width: 0 1px 1px 0px;
                    ">
                    手机号：
                </td>
            </tr>
            <tr>
                <td
                    align="left"
                    style="border: 1px solid #ccc; border-top: 0px; padding-left: 10px">
                    电子邮箱(必填)：
                </td>
                <td
                    align="left"
                    style="
                        border-color: #ccc;
                        border-style: solid;
                        padding-left: 10px;
                        border-width: 0 1px 1px 0px;
                    ">
                    QQ:
                </td>
            </tr>
            <tr>
                <td
                    align="left"
                    style="border: 1px solid #ccc; border-top: 0px; padding-left: 10px">
                    公司电话：
                </td>
                <td
                    align="left"
                    style="
                        border-color: #ccc;
                        border-style: solid;
                        padding-left: 10px;
                        border-width: 0 1px 1px 0px;
                    ">
                    传真：
                </td>
            </tr>
            <tr>
                <td
                    align="left"
                    colspan="2"
                    style="
                        border-color: #ccc;
                        border-style: solid;
                        padding-left: 10px;
                        border-width: 0 1px 1px 1px;
                    ">
                    公司详细地址:
                </td>
            </tr>
        </table>

        <br />
        <p>我司关联用户与贵司发生的行为视为我司行为。</p>
        <p>如有撤销委托、变更代理人等事宜，我司将另行通知。</p>
        <p>特此委托!</p>
        <br />
        <br />
        <p style="text-align: right">单位名称（公章或合同章）</p>
        <p style="text-align: right">年 月 日</p>
        <br />
        <br />
        <p style="color: #f00">
            授权书模板可以通过熊猫点钢官网（www.dianjiabao.com.cn）进行下载或者联系管理员获取；
        </p>
        <p style="color: #f00">如有疑问致电客服：400-997-1366</p>
    </div>
</template>

<style type="text/css" scoped>
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
code,
del,
dfn,
em,
img,
q,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
    margin: 0px;
    padding: 0px;
}
body {
    font-family: 'Arial Unicode MS';
    font-size: 16px;
    margin: 0 auto;
    padding: 10px 2%;
    width: 96%;
}
table {
    border-left: 1px solid;
    border-spacing: 0;
    border-top: 1px solid;
    table-layout: fixed;
    width: 100%;
    word-break: break-strict;
    line-height: 30px;
    font-size: 14px;
}
table th,
table td {
    border-bottom: 0px solid;
    border-right: 0px solid;
    padding: 5px;
}
table td {
    text-align: left;
    color: #333;
    font-size: 12px;
}
h1 {
    font-size: 20px;
    margin: 10px auto;
    line-height: 40px;
    color: #000;
    text-align: center;
}
p {
    font-size: 14px;
    line-height: 24px;
    margin: 5px 0;
}
h3 {
    font-size: 16px;
    line-height: 30px;
    color: #333333;
    margin: 10px 0 10px 0;
}
</style>
<script>
export default {
    // 数据对象
    data() {
        return {};
    },
    // 函数集合
    methods: {},
};
</script>
